<!-- =========================================================================================
  File Name: SaleTransactionEdit.vue
  Description: SaleTransaction Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-sale-transaction-edit">

    <vs-alert color="danger" title="Transacción de venta no encontrada" :active.sync="id_not_found">
      <span>Datos de transacción de venta con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'saleTransactions'}" class="text-inherit underline"> todas las transacciones de venta</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="data_local" class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1">
            <div class="w-full">
              <h4 class="text-blue-800 text-bold mb-2">{{ data_local.number }}</h4>
              <div class="w-full">
                <label style="font-size: smaller;">Fecha</label>
                <div style="width: 250px;">
                  <ejs-datetimepicker v-model="data_local.date" locale="es-GT" placeHolder="Fecha del documento" :readonly="!editing"></ejs-datetimepicker>
                </div>
                <!--                  <flat-pickr :config="configdateTimePicker" v-model="data_local.date" format="dd/MM/yyyy H:m:s" class="ml-2"/>&nbsp;-->
              </div>
            </div>
          </div>

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1">
            <div class="w-full">
              <div class="w-full">
                <label style="font-size: smaller;" v-if="data_local.statusName">Estado</label><br/>
                <b class="text-blue-800 text-bold">{{ data_local.statusName }}</b>
              </div>
              <div class="w-full">
                <label style="font-size: smaller;">Cliente</label><br/>
                <b class="text-blue-800 text-bold">{{ data_local.customerName }}</b>
              </div>
            </div>
          </div>

        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button size="small" class="mr-1" icon-pack="feather" icon="icon-edit" v-if="!editing && data_local.statusId == 'OPE'" @click="editing = true">Editar</vs-button>
              <vs-button size="small" class="mr-1" icon-pack="feather" icon="icon-printer" v-if="!editing && data_local.printedDocument != ''" @click="printDocument">Imprimir</vs-button>
              <vs-button size="small" class="mr-1" color="danger" icon-pack="feather" icon="icon-x" v-if="!editing && data_local.statusId != 'ANU'" @click="confirmVoidRecord">Anular</vs-button>
              <vs-button size="small" class="mr-1" color="danger" icon-pack="feather" icon="icon-trash" v-if="!editing && data_local.statusId == 'OPE'" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button size="small" class="mr-1" color="success" @click="save" v-if="editing && !editingGrid" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button size="small" class="mr-1" color="warning" @click="reset_data" v-if="editing && !editingGrid">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card>
      <vs-tabs>
        <vs-tab label="Productos">
          <div class="flex flex-wrap items-center">
            <ejs-grid v-if="loaded" ref="grid" id="grdSaleTransactionDetail" :dataSource="lines" :load='load' locale='es-GT' :toolbar='toolbarOptions' height="300px" :pageSettings='pageSettings' :editSettings='editSettings'
                      :actionBegin='gridActionBegin' :actionComplete="gridActionComplete">
              <e-columns>
                <e-column field="id" :visible=false headerText="ID" :isPrimaryKey="true" :allowEditing="false"/>
                <e-column field="productId"
                          headerText="Código del producto"
                          width="120"
                          :dataSource="products"
                          :fields="productEditFields"
                          foreignKeyField="id"
                          foreignKeyValue="code"
                          :edit="productEditParams"
                />
                <e-column field="productName" headerText="Nombre del producto" width="300" :allowEditing="false"/>
                <e-column field="warehouseId"
                          headerText="Bodega"
                          width="200"
                          :dataSource="warehouses"
                          :fields="warehouseEditFields"
                          foreignKeyField="id"
                          foreignKeyValue="name"
                          :edit="warehouseEditParams"
                />
                <e-column field="quantity" headerText="Cantidad" textAlign='Right' format="N4" editType='numericedit' :edit='numericParams' width="100"/>
                <e-column field="unitPrice" headerText="Precio" textAlign='Right' format="N2" editType='numericedit' :edit='numericParams' width="100"/>
                <e-column field="discountPercent" headerText="% Descto." textAlign='Right' format="N2" editType='numericedit' :edit='numericParams' width="100"/>
                <e-column field="discountValue" headerText="Descuento" textAlign='Right' format="N2" editType='numericedit' :edit='numericParams' width="100"/>
                <e-column field="amount" headerText="Valor" textAlign='Right' format="N2" editType='numericedit' :edit='numericParams' width="100"/>
                <e-column headerText='Acciones' width=100 :commands='commands' :visible="editing"/>
              </e-columns>
              <e-aggregates>
                <e-aggregate>
                  <e-columns>
                    <e-column type="Custom" columnName="unitPrice" :footerTemplate="`Subtotal:`"/>
                    <e-column type="Sum" field="amount" format="N2"/>
                  </e-columns>
                </e-aggregate>
                <e-aggregate>
                  <e-columns>
                    <e-column type="Custom" columnName="unitPrice" :footerTemplate="`(-) Descuento:`"/>
                    <e-column type="Custom" columnName="amount" format="N2" :footerTemplate="`${data_local.discountAmount}`"/>
                  </e-columns>
                </e-aggregate>
                <e-aggregate>
                  <e-columns>
                    <e-column type="Custom" columnName="unitPrice" :footerTemplate="`TOTAL:`"/>
                    <e-column type="Custom" columnName="amount" format="N2" :footerTemplate="`${data_local.amount}`"/>
                  </e-columns>
                </e-aggregate>
              </e-aggregates>
            </ejs-grid>
          </div>
        </vs-tab>
        <vs-tab label="Pago">
          <div class="flex flex-wrap items-center">
            <ejs-grid v-if="loaded" ref="gridPayments" id="grdSaleTransactionPayment" :dataSource="data_local.payments" :load='loadPaymentsGrid' locale='es-GT' :toolbar='toolbarOptions' height="200px" :pageSettings='pageSettings' :editSettings='editSettings'
                      :actionBegin='gridActionBegin' :actionComplete="gridActionComplete">
              <e-columns>
                <e-column field="id" :visible=false headerText="ID" :isPrimaryKey="true" :allowEditing="false"/>
                <e-column field="description" headerText="Descripción" width="300" :allowEditing="false"/>
                <e-column field="amount" headerText="Valor" textAlign='Right' format="N2" editType='numericedit' :edit='numericParams' width="100"/>
                <e-column headerText='Acciones' width=100 :commands='commands' :visible="editing"/>
              </e-columns>
              <e-aggregates>
                <e-aggregate>
                  <e-columns>
                    <e-column type="Custom" columnName="description" :footerTemplate="`Total pagado:`"/>
                    <e-column type="Sum" field="amount" format="N2"/>
                  </e-columns>
                </e-aggregate>
              </e-aggregates>
            </ejs-grid>
          </div>
        </vs-tab>
        <vs-tab label="Información adicional">
          <div class="vx-row">
            <!-- Information - Col 1 -->
            <div class="vx-col flex-1">
              <div class="w-full">
                <label style="font-size: smaller;">Tipo de documento</label>
                <ejs-dropdownlist highlight=true :dataSource="documentTypes" :fields="{text: 'name', value: 'code'}" v-model="data_local.documentType" :readonly="!editing" :disabled="!editing"></ejs-dropdownlist>
              </div>
              <div class="w-full">
                <label style="font-size: smaller;">Descuento</label>
                <div class="w-full vx-row">
                  <span class="vx-col w-1/8">
                    <ejs-numerictextbox format="P2" :readonly="!editing" textAlign='Right' v-model="discountPercentDisplay"/>
                  </span>
                  <span class="vx-col w-3/8">
                    <ejs-numerictextbox format="N2" :readonly="!editing" textAlign='Right' v-model="data_local.discountAmount"/>
                  </span>
                </div>
              </div>
            </div>

            <!-- Information - Col 2 -->
            <div class="vx-col flex-1">
              <div class="w-full">
                <label style="font-size: smaller;">Comentarios</label>
                <div class="e-float-input">
                  <textarea class="address-field" rows="2" v-model="data_local.comments" :disabled="!editing"></textarea>
                </div>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
  // import {AgGridVue} from "ag-grid-vue";

  var deltaPOS_config = require('@/deltaPOS.config.js')

  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js';
  import Vue from "vue";
  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import {Query} from "@syncfusion/ej2-data";
  import {GridPlugin, Toolbar, Search, Edit, CommandColumn, ForeignKey, Aggregate} from '@syncfusion/ej2-vue-grids';
  import {AutoComplete} from '@syncfusion/ej2-dropdowns';
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import {DateTimePickerPlugin} from '@syncfusion/ej2-vue-calendars';
  import {NumericTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
  import printJS from 'print-js'

  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week

  Vue.use(GridPlugin, AutoComplete);
  Vue.use(DropDownListPlugin);
  Vue.use(DateTimePickerPlugin);
  Vue.use(NumericTextBoxPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);

  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'datetimepicker': {
        placeholder: 'Especifique fecha',
        today: 'Hoy'
      },
      'grid': {
        'EmptyRecord': 'Transacción no tiene productos',
        'Search': 'Buscar',
        'Add': 'Agregar',
        'Edit': 'Modificar',
        'Cancel': 'Cancelar',
        'Update': 'Guardar',
        'Delete': 'Eliminar'
      }
    }
  });

  var elemProduct;
  var productObj;
  var elemWarehouse;
  var warehouseObj;

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        editingGrid: false,
        pageSettings: {pageSize: 10},
        pagination: [10, 25, 50, 100],
        toolbarOptions: ['Search', 'Add', 'Update', 'Cancel'],
        editSettings: {allowEditing: true, allowAdding: false, allowDeleting: true, newRowPosition: 'Bottom', editMode: 'batch'},
        numericParams: {
          params: {
            validateDecimalOnType: true,
            decimals: 4,
            format: "N"
          }
        },
        commands: [
          {type: 'Edit', buttonOption: {cssClass: 'e-flat', iconCss: 'e-edit e-icons'}},
          {type: 'Delete', buttonOption: {cssClass: 'e-flat', iconCss: 'e-delete e-icons'}},
          {type: 'Cancel', buttonOption: {cssClass: 'e-flat', iconCss: 'e-cancel e-icons'}},
          {type: 'Update', buttonOption: {cssClass: 'e-flat', iconCss: 'e-update e-icons'}}
        ],
        allowFiltering: true,
        queryProduct: new Query().select(['searchName', 'id']).take(10),
        queryWarehouse: new Query().select(['name', 'id']).take(10),
        warehouseEditParams: {
          create: function () {
            elemWarehouse = document.createElement('input');
            return elemWarehouse;
          },
          read: () => {
            return warehouseObj.value;
          },
          destroy: () => {
            warehouseObj.destroy();
          },
          write: (args) => {
            warehouseObj = new AutoComplete({
              value: args.rowData[args.column.field],
              dataSource: args.column.columnData,
              fields: {text: 'name', value: 'id'},
              ignoreAccent: true,
              ignoreCase: true,
              allowFiltering: true,
              filtering: this.warehouseFiltering,
              highlight: 'highlight'
            });
            warehouseObj.appendTo(elemWarehouse);
          }
        },
        productEditParams: {
          create: function () {
            elemProduct = document.createElement('input');
            return elemProduct;
          },
          read: () => {
            return productObj.value;
          },
          destroy: () => {
            productObj.destroy();
          },
          write: (args) => {
            productObj = new AutoComplete({
              width: 600,
              value: args.rowData[args.column.field],
              dataSource: args.column.columnData,
              fields: {text: 'code', value: 'id'},
              itemTemplate: '<span><span>${code}</span><span style="right: 0; width: 500px; position:absolute;">${name}</span></span>',
              ignoreAccent: true,
              ignoreCase: true,
              allowFiltering: true,
              filtering: this.productFiltering,
              highlight: 'highlight',
              select: (args) => {
                document.querySelector("#grdSaleTransactionDetailproductName").value = args.itemData.name;
              }
            });
            productObj.appendTo(elemProduct);
          }
        },
        productEditFields: {text: 'code', value: 'id'},
        warehouseEditFields: {text: 'name', value: 'id'},
        configdateTimePicker: {
          enableTime: true,
          dateFormat: 'm/d/Y H:i',
          locale: SpanishLocale,
          allowInput: true
        },
        documentTypes: [],
        warehouses: [],
        data: null,
        data_local: {
          id: 0,
          documentType: '',
          documentTypeName: '',
          document: '',
          date: new Date(),
          statusId: 'OPE',
          statusName: '',
          comments: '',
          printedDocument: '',
          origin: 'deltaPOS'
        },
        lines: [],
        id_not_found: false,
      }
    },
    components: {
      flatPickr
    },
    provide: {
      grid: [Toolbar, Search, Edit, CommandColumn, ForeignKey, Aggregate]
    },
    computed: {
      api() {
        return this.$store.getters.getParameter('connection').apiURL;
      },
      status() {
        return this.$store.state.lists.filter(item => item.list == 'ESTADODOCUMENTO');
      },
      products() {
        return this.$store.state.products;
      },
      discountPercentDisplay() {
        return Math.round(this.data_local.discountPercent / 100 * 100) / 100;
      }
    },
    watch: {
      editing: function(enable) {
        this.lines = JSON.parse(JSON.stringify(this.data.products));
        this.$refs.grid.ej2Instances.editSettings.allowAdding = enable;
        this.$refs.grid.refresh();
      }
    },
    methods: {
      load: function () {
        // this.warehouseEditParams.params.dataSource = warehouses;
        this.$refs.grid.ej2Instances.element.addEventListener('mousedown', function (e) {
          var instance = this.ej2_instances[0];
          if (e.target.classList.contains("e-rowcell")) {
            if (instance.isEdit)
              instance.endEdit();
            let index = parseInt(e.target.getAttribute("Index"));
            instance.selectRow(index);
            instance.startEdit();
          }
        });
      },
      loadPaymentsGrid: function () {
        // this.warehouseEditParams.params.dataSource = warehouses;
        this.$refs.gridPayments.ej2Instances.element.addEventListener('mousedown', function (e) {
          var instance = this.ej2_instances[0];
          if (e.target.classList.contains("e-rowcell")) {
            if (instance.isEdit)
              instance.endEdit();
            let index = parseInt(e.target.getAttribute("Index"));
            instance.selectRow(index);
            instance.startEdit();
          }
        });
      },
      productFiltering: function (e) {
        var searchData = JSON.parse(JSON.stringify(this.products));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          var query = new Query().select(['searchName', 'code', 'name', 'id']);
          query = (e.text !== '') ? query.where('searchName', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },
      warehouseFiltering: function (e) {
        var searchData = JSON.parse(JSON.stringify(this.warehouses));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          var query = new Query().select(['name', 'id']);
          query = (e.text !== '') ? query.where('name', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },
      gridActionBegin: function (args) {
        if (args.requestType == 'save') {
          var cancel = false;
          var validWarehouse = false;
          args.data.productName = '';
          args.data.quantity = Math.abs(args.data.quantity);
          if (args.data.productId) {
            var product = this.$store.state.products.filter(item => item.id == args.data.productId);
            if (product) {
              if (product.length > 0) {
                args.data.productName = product[0].name;
              }
            }
          }
          if (args.data.warehouseId) {
            var warehouse = this.warehouses.filter(item => item.id == args.data.warehouseId);
            if (warehouse) {
              if (warehouse.length > 0) {
                if (args.data.warehouseId == warehouse[0].id) {
                  validWarehouse = true;
                }
              }
            }
          }
          if (args.data.productName == '') {
            this.$vs.notify({
              title: 'Error guardar línea',
              text: 'Debe especificar un producto válido',
              color: 'danger'
            });
            cancel = true;
          }
          if (!validWarehouse) {
            this.$vs.notify({
              title: 'Error guardar línea',
              text: 'Debe especificar una bodega válida',
              color: 'danger'
            });
            cancel = true;
          }
          if (!args.data.quantity || args.data.quantity <= 0) {
            this.$vs.notify({
              title: 'Error guardar línea',
              text: 'Debe especificar una cantidad mayor a cero',
              color: 'danger'
            });
            cancel = true;
          }
          if (cancel) args.cancel = true;
        }
      },
      gridActionComplete: function (args) {
        if (['add', 'beginEdit'].includes(args.requestType)) {
          this.editingGrid = true;
        } else if (['cancel', 'save'].includes(args.requestType)) {
          this.editingGrid = false
        }
        if (args.action) {
          if (args.action == 'add') {
            this.$refs.grid.ej2Instances.dataSource.shift();
            this.$refs.grid.ej2Instances.dataSource.push(args.data);
            this.$refs.grid.refresh();
            var self = this;
            setTimeout(function () {
              self.$refs.grid.addRecord();
            }, 100);
          }
        }
      },
      getDocumentTypes() {
        var self = this;
        this.$http.post(`${this.api}/stock/document_types/list`).then(response => {
          if (response.data.success) {
            self.documentTypes = response.data.data;
          }
        })
      },
      getWarehouses() {
        var self = this;
        this.$http.post(`${this.api}/stock/warehouses/list`).then(response => {
          if (response.data.success) {
            self.warehouses = response.data.data;
          }
        })
      },
      reset_data() {
        if (this.$route.params.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'saleTransactions'});
        }
      },
      printDocumentBAK() {
        var pdf = window.atob(this.data_local.printedDocument);
        var filename = `${this.data_local.number}.pdf`;

        var byteArrays = [];
        var sliceSize = 512;
        for (var offset = 0; offset < pdf.length; offset += sliceSize) {
          var slice = pdf.slice(offset, offset + sliceSize);
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, {type: "application/pdf",});
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          var elem = window.document.createElement('a');
          elem.href = window.URL.createObjectURL(blob);
          elem.download = filename;
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        }
      },
      printDocument() {
        printJS({printable: this.data_local.printedDocument, type: 'pdf', base64: true});
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            this.$http.post(`${this.api}/sale/transactions/data`, {id: id, context: this.$store.state.AppActiveUser}).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
                self.lines = JSON.parse(JSON.stringify(response.data.data.products));
              } else {
                if (id > 0) {
                  self.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      validateForm() {
        var validated = true;
        if (!this.data_local.documentType || this.data_local.documentType == '') {
          this.$vs.notify({
            title: 'Error al guardar documento',
            text: 'Debe seleccionar un tipo de documento',
            color: 'danger'
          });
          validated = false;
        } else {
          var documentType = this.documentTypes.filter(item => item.code == this.data_local.documentType);
          if (documentType.length > 0) {
            this.data_local.documentTypeFunction = documentType[0].functionId
          } else {
            this.$vs.notify({
              title: 'Error al guardar documento',
              text: 'Tipo de documento incorrecto',
              color: 'danger'
            });
          }
        }
        if (!this.data_local.date) {
          this.$vs.notify({
            title: 'Error al guardar documento',
            text: 'Debe seleccionar una fecha de documento',
            color: 'danger'
          });
          validated = false;
        }
        if (this.$refs.grid.ej2Instances.dataSource.length == 0) {
          this.$vs.notify({
            title: 'Error al guardar documento',
            text: 'Debe seleccionar por lo menos un producto en detalle de documento',
            color: 'danger'
          });
          validated = false;
        }
        return validated;
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de transacción de venta',
            type: 'point'
          });
          var self = this;
          this.data_local.products = this.$refs.grid.ej2Instances.dataSource;
          this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
          this.$http.post(`${this.api}/sale/transactions/save`, this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos de la transacción de venta fueron actualizados correctamente',
                color: 'primary'
              });
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.editing = false;
            this.$vs.loading.close();
          });
        }
      },
      confirmVoidRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a anular transacción de venta "${this.data.number}"`,
          accept: this.voidRecord,
          acceptText: "Anular"
        })
      },
      voidRecord() {
        this.$vs.loading({
          text: 'Anulando transacción de venta',
          type: 'point'
        });
        var self = this;
        this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
        this.data_local.context = this.$store.state.AppActiveUser;
        this.$http.post(`${this.api}/sale/transactions/void`, this.data_local).then(response => {
          if (response.data.success) {

            self.$vs.notify({
              title: 'Información actualizada',
              text: 'Transacción de venta fue anulada correctamente',
              color: 'primary'
            });
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.editing = false;
          this.$vs.loading.close();
        });
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar transacción de inventario "${this.data.document}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        /* Below two lines are just for demo purpose */
        this.$router.push({name: 'saleTransactions'});
        this.showDeleteSuccess()

        /* UnComment below lines for enabling true flow if deleting user */
        // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
        //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
        //   .catch(err => { console.error(err)       })
      },
      showDeleteSuccess() {
        this.$vs.notify({
          color: 'success',
          title: 'Transacción de inventario eliminada',
          text: 'La transacción de inventario seleccionada fue eliminada'
        })
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      if (this.id > 0) {
        this.$vs.loading({
          text: 'Cargando datos de transacción de venta',
          type: 'point'
        });
      }
      var self = this;
      this.$http
        .post(`${this.api}/stock/document_types/list`, this.$store.state.AppActiveUser)
        .then(response => {
          if (response.data.success) {
            self.documentTypes = response.data.data;
          }
          self.$http
            .post(`${this.api}/stock/warehouses/list`, self.$store.state.AppActiveUser)
            .then(response => {
              if (response.data.success) {
                self.warehouses = response.data.data;
              }
              self.getData(self.id);
            });
        });
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

  .wrapper {
    max-width: 250px;
    margin: 0 auto;
  }

  .e-grid .e-altrow {
    background-color: #fafafa;
  }

  #avatar-col {
    width: 12rem;
  }

  #page-sale-transaction-edit {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: .4rem;
        word-break: break-all;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width: 370px) {
            display: block;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }
  }

</style>
